import { render, staticRenderFns } from "./WelcomeTourModal.vue?vue&type=template&id=326f5a6a"
import script from "./WelcomeTourModal.vue?vue&type=script&lang=js"
export * from "./WelcomeTourModal.vue?vue&type=script&lang=js"
import style0 from "./WelcomeTourModal.vue?vue&type=style&index=0&id=326f5a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports